<div class="layout-topbar">
   <div class="flex gap-2">
      <button #menubutton type="button" class="topbar-menubutton p-link p-trigger mr-2" (click)="onMenuButtonClick()">
         <i class="pi pi-chevron-right"></i>
      </button>
      <p-menubar [model]="itemsStart" [autoDisplay]="false" [autoHide]="true"> </p-menubar>
   </div>

   <div class="topbar-end flex gap-3 align-items-center pr-4">
      <p-chip
         [label]="selectedTimezone"
         icon="pi pi-hourglass"
         [pTooltip]="'DATA.COMMON.HUSO.TOOLTIP' | translate"
         [tooltipPosition]="'bottom'"
         (click)="showTimezone()"
         [ngStyle]="{ cursor: 'pointer' }"
      ></p-chip>
      <p-divider layout="vertical" [style]="{ 'height': '5px' }" />
      <p-button
         *ngIf="isAllow([PERMISSION_TYPE.FULL_ACCESS])"
         [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-server'"
         [routerLink]="['/tenants']"
         [queryParamsHandling]="'preserve'"
         [pTooltip]="!loading ? tenantName : ''"
         [tooltipPosition]="'bottom'"
         [label]="loading ? 'Cargando...' : (tenantName | ellipsis: 8)"
         severity="secondary"
         text="true"
         styleClass="text-only"
      ></p-button>
      <button type="button" class="p-link m-2" (click)="onProfileButtonClick()">
         <p-avatar
            [label]="letters(user.name)"
            styleClass="w-2rem h-2rem border-circle"
            size="normal"
            [style]="{ 'background-color': '#c1cdd7', color: 'black' }"
            shape="circle"
         ></p-avatar>
      </button>
   </div>
</div>
